export default "/images/choose_img.png?3ca0ec6b562998871e6f8b33d5810f1f";